import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';          // importamos bootstrap a toda la app
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './css/custom/margin.css';                       // css personalizado
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';                              // Configurar Axios globalmente para incluir cookies en todas las solicitudes API (es necesario para el listado)

// importamos la api
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>            
            <App />            
        </BrowserRouter>
    </React.StrictMode>
);